// export async function reminders_List(ownerAsiakasId, token) {
//   const requestOptions = {
//     method: "GET",
//     headers: {
//       "x-access-token": `${token}`,
//     },
//   };
//   const response = await fetch(
//     import.meta.env.VITE_SERVER_URL + "/api/reminders/list/" + ownerAsiakasId,
//     requestOptions
//   );
//   if (!response.ok) return null;
//   const data = await response.json();
//   return data;
// }
export async function reminderRules_List(ownerAsiakasId, token) {
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/reminders/rules/list/" + ownerAsiakasId,
    requestOptions
  );
  if (!response.ok) return null;
  const data = await response.json();
  return data;
}
